function RadioBtn({ label, value, onChange, checked }) {
    return (
        <label>
            <input type="radio" checked={checked} onChange={event => onChange(event, value)}/>
            {label}
        </label>
    );
}

export default RadioBtn;